export default {
    title: "Advisor Recommendations",
    noItems: "No recommendations"
}